<div id="notfound">
	<div class="notfound">
		<div class="notfound-bg">
			<div></div>
			<div></div>
			<div></div>
		</div>
		<h1>{{initMsg}}</h1>
		<h2>{{successMsg}}</h2>
		<a [routerLink]="['/']">home</a>
		<div class="notfound-social">
			<a href="#"><i class="fa fa-whatsapp"></i></a>
			<a href="#"><i class="fa fa-telegram"></i></a>
		</div>
	</div>
</div>